import { render, staticRenderFns } from "./editIncome.vue?vue&type=template&id=062c9150&scoped=true&"
import script from "./editIncome.vue?vue&type=script&lang=js&"
export * from "./editIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062c9150",
  null
  
)

export default component.exports